import { render, staticRenderFns } from "./selectgoodsElement.vue?vue&type=template&id=133dfec4&scoped=true"
import script from "./selectgoodsElement.vue?vue&type=script&lang=js"
export * from "./selectgoodsElement.vue?vue&type=script&lang=js"
import style0 from "./selectgoodsElement.vue?vue&type=style&index=0&id=133dfec4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133dfec4",
  null
  
)

export default component.exports